module.exports = __webpack_public_path__ + "static/media/move.04f65d1.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/move.wav
// module id = 154
// module chunks = 1